import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromBasketAccounts from './reducers/basket-accounts.reducer';
import * as fromBasketData from './reducers/basket-data.reducer';
import * as fromBasketLoaders from './reducers/basket-loaders.reducer';
import * as fromBasketManualDiscounts from './reducers/basket-manual-discounts.reducer';
import * as fromBasketTrackingPayloads from './reducers/basket-tracking-payloads.reducer';
import * as fromModalsBasket from './reducers/basket-modals.reducer';
import * as fromConfiguration from './reducers/basket-options.reducer';
import * as fromBasketTracking from './reducers/basket-tracking.reducer';
import * as fromBasketUI from './reducers/basket-ui.reducer';

export const basketFeatureKey = 'basket';

export interface BasketState {
  [fromConfiguration.basketOptionsFeatureKey]: fromConfiguration.State;
  [fromBasketData.basketDataFeatureKey]: fromBasketData.State;
  [fromBasketAccounts.basketAccountsFeatureKey]: fromBasketAccounts.State;
  [fromBasketLoaders.basketLoadersFeatureKey]: fromBasketLoaders.State;
  [fromModalsBasket.basketModalsFeatureKey]: fromModalsBasket.State;
  [fromBasketUI.basketUiFeatureKey]: fromBasketUI.State;
  [fromBasketManualDiscounts.basketManualDiscountsFeatureKey]: fromBasketManualDiscounts.State;
  [fromBasketTrackingPayloads.basketTrackingPayloadsFeatureKey]: fromBasketTrackingPayloads.State;
  [fromBasketTracking.basketTrackingFeatureKey]: fromBasketTracking.State;
}

export interface State {
  [basketFeatureKey]: BasketState;
}

export const initialState: BasketState = {
  [fromConfiguration.basketOptionsFeatureKey]: fromConfiguration.initialState,
  [fromBasketData.basketDataFeatureKey]: fromBasketData.initialState,
  [fromBasketAccounts.basketAccountsFeatureKey]:
    fromBasketAccounts.initialState,
  [fromBasketLoaders.basketLoadersFeatureKey]: fromBasketLoaders.initialState,
  [fromModalsBasket.basketModalsFeatureKey]: fromModalsBasket.initialState,
  [fromBasketUI.basketUiFeatureKey]: fromBasketUI.initialState,
  [fromBasketManualDiscounts.basketManualDiscountsFeatureKey]:
    fromBasketManualDiscounts.initialState,
  [fromBasketTrackingPayloads.basketTrackingPayloadsFeatureKey]:
    fromBasketTrackingPayloads.initialState,
  [fromBasketTracking.basketTrackingFeatureKey]:
    fromBasketTracking.initialState,
};

/** Provide reducer in AoT-compilation happy way */
export function reducers(state: BasketState | undefined, action: Action) {
  return combineReducers({
    [fromConfiguration.basketOptionsFeatureKey]: fromConfiguration.reducer,
    [fromBasketData.basketDataFeatureKey]: fromBasketData.reducer,
    [fromBasketAccounts.basketAccountsFeatureKey]: fromBasketAccounts.reducer,
    [fromBasketLoaders.basketLoadersFeatureKey]: fromBasketLoaders.reducer,
    [fromModalsBasket.basketModalsFeatureKey]: fromModalsBasket.reducer,
    [fromBasketUI.basketUiFeatureKey]: fromBasketUI.reducer,
    [fromBasketManualDiscounts.basketManualDiscountsFeatureKey]:
      fromBasketManualDiscounts.reducer,
    [fromBasketTrackingPayloads.basketTrackingPayloadsFeatureKey]:
      fromBasketTrackingPayloads.reducer,
    [fromBasketTracking.basketTrackingFeatureKey]: fromBasketTracking.reducer,
  })(state, action);
}

export const selectBasketState =
  createFeatureSelector<BasketState>(basketFeatureKey);
